import lodash from 'lodash'
import assert from 'minimalistic-assert'

export function verifyOnlyFeePayerChanged(beforeTx, afterTx) {
  assert(
    beforeTx.signatures.length + 1 === afterTx.signatures.length &&
      beforeTx.message.header.numRequiredSignatures + 1 ===
        afterTx.message.header.numRequiredSignatures,
    'A signature was not added for the new signer'
  )
  beforeTx.signatures.forEach((signature, index) => {
    assert(
      lodash.isEqual(signature, afterTx.signatures[index + 1]),
      'Existing signatures do not match'
    )
  })
  assert(
    beforeTx.message.accountKeys.length + 1 === afterTx.message.accountKeys.length,
    'Fee payer account key was not added'
  )
  beforeTx.message.accountKeys.forEach((accountKey, index) => {
    assert(
      lodash.isEqual(accountKey, afterTx.message.accountKeys[index + 1]),
      'Existing account keys do not match'
    )
  })

  assert(
    beforeTx.message.instructions.length === afterTx.message.instructions.length,
    'No new instructions are allowed'
  )

  beforeTx.message.instructions.forEach(({ programIdIndex }, index) => {
    assert(
      programIdIndex + 1 === afterTx.message.instructions[index]?.programIdIndex,
      'Instructions program ids were not updated'
    )
  })

  beforeTx.message.instructions.forEach(({ accounts }, index) => {
    assert(
      lodash.isEqual(
        accounts.map((id) => id + 1),
        afterTx.message.instructions[index].accounts
      ),
      'Instructions account key indexes were not updated'
    )
  })

  beforeTx.message.instructions.forEach((instruction, index) => {
    assert(
      lodash.isEqual(
        { ...instruction, accounts: null, programIdIndex: null },
        {
          ...afterTx.message.instructions[index],
          accounts: null,
          programIdIndex: null,
        }
      ),
      'Instructions do not match in some attributes'
    )
  })

  afterTx.message.indexToProgramIds.forEach((value, key) => {
    assert(afterTx.message.accountKeys[key] === value, 'IndexToProgramIds do not match accountKeys')
  })

  assert(
    lodash.isEqual(
      {
        ...beforeTx,
        signatures: null,
        message: null,
      },
      {
        ...afterTx,

        signatures: null,
        message: null,
      }
    ),
    'Transactions do not match in some attributes'
  )

  assert(
    lodash.isEqual(
      {
        ...beforeTx.message,
        header: { ...beforeTx.message.header, numRequiredSignatures: null },
        accountKeys: null,
        instructions: null,
        indexToProgramIds: null,
      },
      {
        ...afterTx.message,
        header: { ...afterTx.message.header, numRequiredSignatures: null },
        accountKeys: null,
        instructions: null,
        indexToProgramIds: null,
      }
    ),
    'Transactions do not match in some attributes'
  )
}
